exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zoom-control {\n  pointer-events: auto; }\n  .zoom-control .btn {\n    padding: 12px 20px; }\n    .zoom-control .btn:focus {\n      outline: none;\n      z-index: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/core/maps/controls/zoom.component.scss
// module id = ../../../../../src/app/core/maps/controls/zoom.component.scss
// module chunks = 0